<template>
    <v-flex v-if="value">
        <v-btn :href="tripUrlsUrl">
            Manage URLs
        </v-btn>
    </v-flex>
</template>

<script>
/**
 * Triggers a request to the server to update this room type
 */
export default {
    name: 'ies-ical-feed',
    props: ['field', 'value'],
    data () {
        return {
            tripUrlsUrl: null
        }
    },

    mounted: function(){
        this.tripUrlsUrl = "/trips/" + this.value + "/trip-urls/list";
    }
}
</script>
